import { Pipe, PipeTransform } from '@angular/core';
import { supportedCountries } from '@authentication/model/create-account.model';
import { LanguageService } from '@core/services/language.service';
import { Language } from '@shared/model/languages.enum';
import { iif, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
	name: 'countryName',
	standalone: true,
})
export class CountryNamePipe implements PipeTransform {
	constructor(private readonly languageService: LanguageService) {}
	transform(countryCode: string): Observable<string> {
		const foundCountry = supportedCountries.find((country) => country.iso === countryCode);
		return iif(
			() => Boolean(foundCountry),
			this.languageService.currentLanguage$.pipe(
				map((language) => (language === Language.PL ? foundCountry.pl : foundCountry.en))
			),
			of(countryCode)
		);
	}
}
